import {useSelector} from "react-redux";
import Table from '@/components/common/Table';
import Button from '@/components/common/Button';
import { ReactComponent as RiEditLine } from '@/assets/icons/ri-edit-line.svg';
import { currencyFormat } from '@/utils';
import {RootState, useAppDispatch} from "@/store";
import {constructTableMetaFromPaging2} from "@/utils/paging";
import {refundDetailActions} from "@/store/refund-detail/slice";
import {invoiceActions} from "@/store/invoice/slice";
import {colors} from "@/pages/Refund/constant";

const renderRefundId = (v) => (
	<div className="text-jsm text-black-primary font-bold">{v}</div>
)
const renderAction = (id: string, handleEditClick: Function) => (
	<Button
		onClick={() => {handleEditClick(id)}}
		type={null}
		variant="secondary"
		className="border-stroke-subtle border px-4"
	>
		<div className="flex gap-2 justify-center items-center h-4">
			<RiEditLine />
			Edit
		</div>
	</Button>
);
const renderStatus = (status) => (
	<div
		className={`flex px-4 py-1 w-fit rounded capitalize font-medium
    ${colors[status]}`}
	>
		{status.replace('_', ' ')}
	</div>
);
const renderNominal = (nominal) => (
	<div className="text-jsm text-black-primary font-medium">
		{currencyFormat(nominal)}
	</div>
);
const renderCreateDate = (date) => {
	const newDate = new Date(date);
	return (
		<div className="text-jsm">
			{newDate.toLocaleDateString()},{' '}
			{newDate.toLocaleTimeString('en-GB', {
				hour: '2-digit',
				minute: '2-digit',
			})}
		</div>
	);
};
const renderGeneric = (value) => (
	<div className="text-jsm font-normal">{value}</div>
);
const renderObjectAttr = (object, key) =>
	object && key && object[key] ? renderGeneric(object[key]) : <span>-</span>
const HEADERS: TableHeader[] = [
	{
		label: 'Refund ID',
		key: 'custom_id',
	},
	{
		label: 'Invoice ID',
		key: 'invoice',
	},
	{
		label: 'Customer',
		key: 'customer',
	},
	{
		label: 'Nominal',
		key: 'total_price',
	},
	{
		label: 'Status',
		key: 'status',
	},
	{
		label: 'Created Date',
		key: 'created_at',
	},
	{
		label: 'Action',
		key: 'actionId',
	},
];
const SORT: TableSort = {
	type: 'SERVER',
	handler: () => {},
};

const RefundTable = () => {
	const { refunds, paging } = useSelector((rootState: RootState) => rootState.refundSummary.state)
	const dispatch = useAppDispatch()
	const showEditModal = (id: string) => {
		dispatch(refundDetailActions.resetRefundDetail())
		dispatch(invoiceActions.resetInvoice())
		const params = {
			id,
			show: true
		} as RefundDetailModalPayload
		dispatch(refundDetailActions.showRefundDetailModal(params))
	}


	const constructTableBody = (): TableBody => ({
		data: refunds.map(r => ({
			id: r.id,
			value: {
				...r,
				actionId: r.id
			} as RefundVO
		})),
		component: {
			custom_id: renderRefundId,
			invoice: (v: RefundInvoice) => renderObjectAttr(v, 'custom_id'),
			customer: (c: RefundCustomer) => renderObjectAttr(c, 'name'),
			total_price: renderNominal,
			status: renderStatus,
			created_at: renderCreateDate,
			actionId: (id) => renderAction(id, showEditModal)
		},
	})
	
	return <Table headers={HEADERS} body={constructTableBody()} sort={SORT} meta={constructTableMetaFromPaging2(paging)} />
}

export default RefundTable;
